module.exports = __webpack_public_path__ + "media/audio25.36733242.mp3";